import React, { createContext, useContext, useState } from "react";
import { User } from "@/user/user";
import { useUser } from "@/api/api";
import Hotjar from "@hotjar/browser";
import ReactGA from "react-ga4";
import { usePostHog } from "posthog-js/react";

type AuthenticationContextType = {
  user: User
};

const getTrackingId = (tool: string) => {
  const host = window.location.hostname;

  if (host === "qa.copilot.thalolabs.com") {
    if (tool === "hotjar") return 3841078;
    else if (tool === "ga") return "G-30EMBKCLJW";
  } else if (host === "copilot.thalolabs.com") {
    if (tool === "hotjar") return 3840753;
    else if (tool === "ga") return "G-4Q2C1NGD40";
  }
  return null;
};

const AuthenticationContext = createContext<AuthenticationContextType | undefined>(undefined);

export function AuthenticationContextProvider({ children }: any) {

  const { data: user } = useUser();
  const posthog = usePostHog();

  const [hotjarInitialized, setHotjarInitialized] = useState(false);

  React.useEffect(() => {
    if (user) {
      ReactGA.set({ user_id: user.id });
      posthog.identify(user.username, { email: user.email, is_staff: user.is_staff })
    }
  }, [user]);

  React.useEffect(() => {
    const hotjarVersion = 6;
    const hotjarId = getTrackingId("hotjar");
    if (hotjarInitialized) {
      return;
    }

    if (hotjarId && user) {
      // @ts-ignore
      Hotjar.init(hotjarId, hotjarVersion);
      setHotjarInitialized(true);
      // @ts-ignore
      Hotjar.identify(user.username, {
        first_name: user.first_name,
        last_name: user.last_name,
        is_staff: user.is_staff
      });
    }
  }, [user]);

  return (
    <AuthenticationContext.Provider
      value={{
        user
      }}
    >
      {children}
    </AuthenticationContext.Provider>
  );
}


export function useAuthentication() {
  const context = useContext(AuthenticationContext);
  if (context === undefined) {
    throw new Error("Authentication Context must be used within its provider");
  }

  return context
}
